/* Modifiche ai layout del configuratore targhe. Le voci qui sostituiscono quelle in targa-customizer.js. */
window.TargaLayouts = {
};
